import React from 'react';
import ReactDOM from 'react-dom';
// Routes
import Routes from './Routes';

ReactDOM.render(
  <Routes />,
  document.getElementById('root')
);
